import {postRequest} from "@/utils/axios"
const actions = {
	checkUser({commit, state}) {
		if (!state.user) {
			return false;
		}
		postRequest("/invitation/check", {token: state.user.token}).then(data => {
			if (data.status == "TX0000") {
				let user = data.data;
				commit("setUser", user);
			} else {
				commit("clearUser");
			}
		})
	}
}

export default actions
